import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M4 14v11a3 3 0 003 3h18a3 3 0 003-3V14zm7 4a1 1 0 011 1 1 1 0 001 1h6a1 1 0 001-1 1 1 0 012 0 3 3 0 01-3 3h-6a3 3 0 01-3-3 1 1 0 011-1z"/><rect x="2" y="4" width="28" height="8" rx="1"/>';
export var ArchiveSVG = function ArchiveSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ArchiveSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ArchiveSVG);